import { Scrollable } from 'components/scrollable'
import numeral from 'numeral'
import { ComponentType, Fragment, useState } from 'react'
import { GoCheck } from 'react-icons/go'
import { FormattedMessage } from 'react-intl'
import { Button, Col, Row } from 'reactstrap'
import { up } from 'styled-breakpoints'
import styled from 'styled-components'

const Area: ComponentType<{ property: any }> = ({ property }) => {
  const hasAreaTotal = !!property.area?.total
  const hasAreaWidth = !!property.area?.width
  const hasAreaDepth = !!property.area?.depth
  const hasAreaBuilt = !!property.area?.built
  const hasAreaType = !!property.area?.type

  return (
    <Fragment>
      {hasAreaTotal && (
        <div className="py-15 pr-30 d-flex justify-content-between border-top">
          <div>Superficie total</div>
          <div className="text-primary">
            <FormattedMessage id="sqrmeters" values={{ meters: property.area.total }} />
          </div>
        </div>
      )}
      {hasAreaWidth && (
        <div className="py-15 pr-30 d-flex justify-content-between border-top">
          <div>Frente</div>
          <div className="text-primary">
            <FormattedMessage id="meters" values={{ meters: property.area.width }} />
          </div>
        </div>
      )}
      {hasAreaDepth && (
        <div className="py-15 pr-30 d-flex justify-content-between border-top">
          <div>Fondo</div>
          <div className="text-primary">
            <FormattedMessage id="meters" values={{ meters: property.area.depth }} />
          </div>
        </div>
      )}
      {hasAreaBuilt && (
        <div className="py-15 pr-30 d-flex justify-content-between border-top">
          <div>Construcción</div>
          <div className="text-primary">
            <FormattedMessage id="sqrmeters" values={{ meters: property.area.built }} />
          </div>
        </div>
      )}
      {hasAreaType && (
        <div className="py-15 pr-30 d-flex justify-content-between border-top">
          <div>Forma del terreno</div>
          <div className="text-primary">
            <FormattedMessage id={`area.type.${property.area.type}`} />
          </div>
        </div>
      )}
    </Fragment>
  )
}

const Sale: ComponentType<{ property: any }> = ({ property }) => {
  return (
    <Fragment>
      <div className="py-15 pr-30 d-flex justify-content-between">
        <div>
          Precio de <strong>venta</strong>
        </div>
        <div className="text-primary">
          {numeral(property.sale.price).format('$0,0')} {property.currency}
        </div>
      </div>
      <div className="py-15 pr-30 d-flex justify-content-between border-top">
        <div>Apartado</div>
        <div className="text-primary">
          {numeral(property.sale.advancePayment).format('$0,0')} {property.currency}
        </div>
      </div>
      <div className="py-15 pr-30 d-flex justify-content-between border-top">
        <div>Vigencia del apartado</div>
        <div className="text-primary">
          <FormattedMessage id="days" values={{ days: property.sale.advanceValidity }} />
        </div>
      </div>
      <div className="py-15 pr-30 d-flex justify-content-between border-top">
        <div>Enganche</div>
        <div className="text-primary">
          {numeral(property.sale.downPayment).format('$0,0')} {property.currency}
        </div>
      </div>
      {property.sale.balanceType === 'ondelivery' && (
        <div className="py-15 pr-30 d-flex justify-content-between border-top">
          <div>
            Saldo <strong>contra entrega</strong>
          </div>
          <div className="text-primary">
            {numeral(property.sale.price - (property.sale.advancePayment + property.sale.downPayment)).format('$0,0')}{' '}
            {property.currency}
          </div>
        </div>
      )}
      {property.sale.balanceType === 'installments' && (
        <div className="py-15 pr-30 d-flex justify-content-between border-top">
          <div>
            Saldo a <strong>{property.sale.installments} mensualidades</strong>
          </div>
          <div className="text-primary">
            {numeral(
              (property.sale.price - (property.sale.advancePayment + property.sale.downPayment)) /
              property.sale.installments,
            ).format('$0,0')}{' '}
            {property.currency}
          </div>
        </div>
      )}
      {property.sale.balanceType === 'other' && (
        <div className="py-15 pr-30 border-top">
          <div>
            Saldo <strong>Otro</strong>
          </div>
          <div className="text-primary">{property.sale.other}</div>
        </div>
      )}
    </Fragment>
  )
}

const Rent: ComponentType<{ property: any }> = ({ property }) => {
  return (
    <Fragment>
      <div className="py-15 pr-30 d-flex justify-content-between">
        <div>Renta mensual</div>
        <div className="text-primary">
          {numeral(property.rent.monthPrice).format('$0,0')} {property.currency}
        </div>
      </div>
      <div className="py-15 pr-30 d-flex justify-content-between border-top">
        <div>Costo del convenio</div>
        <div className="text-primary">
          {numeral(property.rent.agreementPrice).format('$0,0')} {property.currency}
        </div>
      </div>
      <h5 className="mb-15 mt-50 font-size-14 text-uppercase text-primary font-weight-bold">Requerimientos</h5>
      <ul className="list-unstyled">
        <li className="py-7">
          <GoCheck className="text-primary" /> Renta mínima de 12 meses
        </li>
        <li className="py-7">
          <GoCheck className="text-primary" /> Un mes de renta por adelantado
        </li>
        <li className="py-7">
          <GoCheck className="text-primary" /> Un mes de depósito en garrantía o 3 meses de renta sin aval
        </li>
        <li className="py-7">
          <GoCheck className="text-primary" /> Aval con propiedad en Mérida
        </li>
      </ul>
    </Fragment>
  )
}

const Measurements: ComponentType<{ property: any }> = ({ property }) => {
  return (
    <Fragment>
      {property.measurements?.built ? (
        <div className="py-15 pr-30 d-flex justify-content-between">
          <div>Antigüedad</div>
          <div className="text-primary">
            <FormattedMessage
              id="years"
              values={{
                years: new Date().getFullYear() - property.measurements.built,
              }}
            />
          </div>
        </div>
      ) : null}
      {property.measurements?.built ? (
        <div className="py-15 pr-30 d-flex justify-content-between border-top">
          <div>Construcción</div>
          <div className="text-primary">{property.measurements.built}</div>
        </div>
      ) : null}
      {property.measurements?.improved ? (
        <div className="py-15 pr-30 d-flex justify-content-between border-top">
          <div>Última remodelación</div>
          <div className="text-primary">{property.measurements.improved}</div>
        </div>
      ) : null}
    </Fragment>
  )
}

const TabsWrapper = styled(Scrollable)`
  overflow: auto;
  display: flex;
  padding: 0 15px;
  margin: 0 -15px 32px -15px;

  ${up('sm')} {
    padding: 0;
    margin: 0 0 24px 0;
  }
`

export const Tabs: ComponentType<{ property: any }> = ({ property }) => {
  const [tab, setTab] = useState('area')
  const hasSale = property.role.includes('sale')
  const hasRent = property.role.includes('rent')

  return (
    <Row>
      <Col lg={12}>
        <TabsWrapper>
          <Button color="tab" className="text-nowrap tab-active-area" onClick={() => setTab('area')} active={tab === 'area'}>
            Terreno
          </Button>
          {/* <Button color="tab" className="text-nowrap" onClick={() => setTab('sale')} active={tab === 'sale'}>
            {hasSale && hasRent ? 'Aspectos financieros de venta' : 'Aspectos financieros'}
          </Button>
          {hasRent && (
            <Button color="tab" className="text-nowrap" onClick={() => setTab('rent')} active={tab === 'rent'}>
              Aspectos financieros de renta
            </Button>
          )} */}
          {property.measurements?.built || property.measurements?.improved ? (
            <Button
              color="tab"
              className="text-nowrap tab-active-measurements"
              onClick={() => setTab('measurements')}
              active={tab === 'measurements'}

            >
              Antecedentes
            </Button>
          ) : null}
        </TabsWrapper>
      </Col>
      <Col lg={7} className="print--none">
        {tab === 'area' && <Area property={property} />}
        {tab === 'sale' && <Sale property={property} />}
        {tab === 'rent' && <Rent property={property} />}
        {tab === 'measurements' && <Measurements property={property} />}
      </Col>
      <Col className="print--only print--wrap-area">
        <Area property={property} />
      </Col>
      <Col className="print--only print--wrap-measurements" >
        <Measurements property={property} />
      </Col >
    </Row >
  )
}
